<template>
<span
    class="inline-flex items-center px-1.5 py-0.5 rounded text-xs border align-middle font-medium bg-gray-100 text-gray-800 border-gray-100"
>
    <span class="capitalize">
        {{ getActionLabel }}
    </span>
</span>
</template>

<script>
import {isCustomColor} from "../../../../helpers/common";
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import {computed} from "vue";

export default {
    name: "ReferralAction",
    props: {
        action: {
            type: String,
            required: true
        },
        textColor: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const portalContentAndDesignStore = usePortalContentAndDesignStore();
        
        const getActionLabel = computed(() => {
            const actionLower = props.action?.toLowerCase() || '';
            
            if (!['signup', 'goal'].includes(actionLower)) {
                return portalContentAndDesignStore.translationSettings.portal_translation_general_action_sale || 'Sale';
            }
            
            if (actionLower === 'signup') {
                return portalContentAndDesignStore.translationSettings.portal_translation_general_action_signup || 'Signup';
            }
            
            if (actionLower === 'submitted') {
                return portalContentAndDesignStore.translationSettings.portal_translation_general_action_submitted || 'Submitted';
            }
            
            return props.action;
        });
        
        return {
            getActionLabel
        };
    },
    methods: {
        isCustomColor
    }
}
</script>
